import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

interface Props {
  open: boolean;
  title: string;
  message: string;
  confirm: () => void;
  deny: () => void;
  confirmText?: string;
  denyText?: string;
  DialogProps?: any;
  disableOK?: boolean;
  confirmColor?: 'primary' | 'error';
  denyVariant?: 'contained' | 'text';
}

const confirmDialog = ({
  open,
  title,
  message,
  confirm,
  deny,
  confirmText,
  denyText,
  DialogProps,
  disableOK = false,
  confirmColor = 'primary',
  denyVariant = 'contained',
}: Props) => (
  <Dialog open={open} onClose={deny} {...DialogProps}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <Typography>{message}</Typography>
    </DialogContent>
    <DialogActions>
      <Button color="secondary" variant={denyVariant} onClick={deny}>
        {denyText || 'Avbryt'}
      </Button>
      <Button disabled={disableOK} variant="contained" color={confirmColor} onClick={confirm}>
        {confirmText || 'OK'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default confirmDialog;
